import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const simulacaoRoutes: Routes = [
  {
    path: 'simular-perfil',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Simulador de Perfil',
      breadcrumb: [{ label: 'Simulador de Perfil' }],
      roles: [Role.SIMULACAO_INICIAR],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./simular-perfil.component').then(
            (m) => m.SimularPerfilComponent,
          ),
        data: {
          title: 'Simulador de Perfil',
          roles: [Role.SIMULACAO_INICIAR],
        },
      },
    ],
  },
];
